import * as React from "react";

function SvgRefiner(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...{ ...props, ref }}
    >
      <defs>
        <rect
          id="Refiner_svg__a"
          x={0}
          y={0}
          width={108}
          height={140}
          rx={12}
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="Refiner_svg__b" fill="#fff">
          <use xlinkHref="#Refiner_svg__a" />
        </mask>
        <use
          fill="#90B4F1"
          transform="matrix(1 0 0 -1 0 140)"
          xlinkHref="#Refiner_svg__a"
        />
        <path
          fill="#FFF"
          opacity={0.26}
          mask="url(#Refiner_svg__b)"
          d="M0 70h108v35H0z"
        />
        <path
          fill="#FFF"
          opacity={0.62}
          mask="url(#Refiner_svg__b)"
          d="M0 0h108v35H0z"
        />
        <path
          fill="#FFF"
          opacity={0.46}
          mask="url(#Refiner_svg__b)"
          d="M0 35h108v35H0z"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgRefiner);
